/**
 * Módulo Materialidad — registro independiente (paridad Visor / Trámites / Despacho).
 * Entrada canónica: /materialidad/expediente (sin hub intermedio de una sola tarjeta).
 */
import { Navigate } from "react-router-dom";
import PanelGeneral from "@/pages/PanelGeneral";
import Clientes from "@/pages/Clientes";
import Ayuda from "@/pages/Ayuda";
import DatosMaestrosHub from "@/pages/DatosMaestrosHub";
import TramitesMaterialidadPage from "@/pages/tramites/TramitesMaterialidadPage";
import { buildModuloFromTabs, createModuloTab } from "@/modules/moduloTabRegistry";
import {
  MATERIALIDAD_CONTEXT_LABEL,
  MATERIALIDAD_EXPEDIENTE_PATH,
  MATERIALIDAD_INICIO_PATH,
  MATERIALIDAD_MODULE_PATHS,
  MODULO_MATERIALIDAD_CARD,
  MODULO_MATERIALIDAD_ID,
} from "@/modules/materialidad/manifest";
import { TRAMITES_MATERIALIDAD_PATH } from "@/modules/tramites/tramitesService";

const MATERIALIDAD_TABS = [
  createModuloTab({
    index: true,
    path: "/",
    label: "Panel General",
    iconKey: "panel",
    end: true,
    showInNav: false,
    testid: "nav-panel-general",
    component: <PanelGeneral />,
  }),
  // Alias de «inicio»: redirige al expediente (evita tarjeta duplicada del Panel).
  createModuloTab({
    path: MATERIALIDAD_INICIO_PATH,
    label: "Inicio del módulo",
    description: "Expediente documental y materialidad por empresa.",
    iconKey: "panel",
    showInNav: false,
    hubCard: false,
    testid: "nav-materialidad-inicio",
    component: <Navigate to={MATERIALIDAD_EXPEDIENTE_PATH} replace />,
  }),
  createModuloTab({
    path: "/datos-maestros",
    label: "Datos Maestros",
    description: "Catálogo fiscal compartido (RFC, contacto, FIEL).",
    iconKey: "database",
    testid: "nav-materialidad-datos-maestros",
    hubCard: false,
    component: <DatosMaestrosHub />,
  }),
  createModuloTab({
    path: "/clientes",
    label: "Clientes",
    description: "Contribuyentes fiscales compartidos.",
    iconKey: "clients",
    hubOnlyNav: true,
    testid: "nav-materialidad-clientes",
    component: <Clientes />,
  }),
  createModuloTab({
    path: MATERIALIDAD_EXPEDIENTE_PATH,
    label: "Expediente documental",
    description:
      "Faltantes por periodo, detección CFDI, riesgos EFOS/opinión y exportación PDF.",
    iconKey: "folder",
    navSection: "Documentación",
    testid: "nav-materialidad-expediente",
    component: <TramitesMaterialidadPage />,
  }),
  createModuloTab({
    path: "/ayuda",
    label: "Ayuda y Manuales",
    iconKey: "help",
    hubOnlyNav: true,
    showInNav: false,
    component: <Ayuda />,
  }),
];

const MATERIALIDAD_EXTRA_ROUTES = [
  {
    path: TRAMITES_MATERIALIDAD_PATH.replace(/^\//, ""),
    element: <Navigate to={MATERIALIDAD_EXPEDIENTE_PATH} replace />,
  },
];

export const MODULO_MATERIALIDAD = buildModuloFromTabs({
  id: MODULO_MATERIALIDAD_ID,
  card: MODULO_MATERIALIDAD_CARD,
  contextLabel: MATERIALIDAD_CONTEXT_LABEL,
  tabs: MATERIALIDAD_TABS,
  extraRoutes: MATERIALIDAD_EXTRA_ROUTES,
});

// Primera ruta operativa: expediente (no el alias /inicio).
MODULO_MATERIALIDAD.getDefaultRoute = () => MATERIALIDAD_EXPEDIENTE_PATH;

export function isMaterialidadCrossModulePath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (MATERIALIDAD_MODULE_PATHS.has(path)) return true;
  if (path === TRAMITES_MATERIALIDAD_PATH) return true;
  return path.startsWith("/materialidad/");
}

export const getModuloMaterialidadNavItems = () => MODULO_MATERIALIDAD.getNavItems();
export const getModuloMaterialidadPaths = () => MODULO_MATERIALIDAD.getPaths();
export const getModuloMaterialidadDefaultRoute = () => MODULO_MATERIALIDAD.getDefaultRoute();
export const isModuloMaterialidadPath = (pathname) => MODULO_MATERIALIDAD.isPathAllowed(pathname);
export const getModuloMaterialidadContextLabel = () => MODULO_MATERIALIDAD.getContextLabel();
export const getModuloMaterialidadRoutes = () => MODULO_MATERIALIDAD.getRoutes();
